define('viewmodels/modals/dialogs/ChangePasswordDialog',['knockout'], function (ko) {

    var ChangePasswordDialog = function (
        dialog,
        formFields,
        settingsModel,
        wpChangePasswordModal,
        wpChangeEmailModal
    ) {
        var self = this;

        self.dialog = dialog;

        self.translations = {
            modalHeader: wpChangePasswordModal('window_header'),
            newPasswordTip: wpChangePasswordModal('new_password_tip'),
            confirm: wpChangeEmailModal('confirm_button'),
            labels: {
                newPasswordField: wpChangePasswordModal('password_field_label'),
                oldPasswordField: wpChangePasswordModal('old_password_field_label')
            },
            messages: {
                wrongPassword: wpChangeEmailModal('wrong_password')
            }
        };

        self.valid = ko.observable(true);

        self.oldPasswordField = formFields.passwordField(settingsModel.oldPlaintextPassword);
        self.newPasswordField = formFields.passwordField(settingsModel.newPlaintextPassword);

        self.command = settingsModel.createChangePasswordCommand(
            function () {
                self.oldPasswordField.value('');
                self.newPasswordField.value('');
                self.close();
            },
            function () {
                self.valid(false);
            }
        );
    };

    ChangePasswordDialog.prototype.close = function () {
        this.dialog.close(this);
    };

    return ChangePasswordDialog;
});

